import { Dialog } from '@mui/material'
import React, { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { MdArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md'
import { useSelector } from 'react-redux'
import Form from '../components/Form'
import FormItem from '../components/Form/FormItem'
import Button from '../components/General/Button'
import InputText from '../components/Inputs/InputText'
import InputUpload from '../components/Inputs/InputUpload'
import Select from '../components/Inputs/Select'
import { RootState } from '../redux/store'

const RegisterForm: React.FC<IRegisterForm> = ({ onCancel, onSubmit }) => {
  const form = useForm()

  const user = useSelector((state: RootState) => state.auth.user)

  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'G',
      text: 'G',
    },
  ]

  const countries = [{ text: 'Venezuela', value: 'ven' }]

  const states = [
    { text: 'Amazonas', value: 'amz' },
    { text: 'Anzoátegui', value: 'anz' },
    { text: 'Apure', value: 'apr' },
    { text: 'Aragua', value: 'arg' },
    { text: 'Barinas', value: 'barn' },
    { text: 'Bolívar', value: 'blv' },
    { text: 'Carabobo', value: 'cara' },
    { text: 'Cojedes', value: 'coje' },
    { text: 'Delta Amacuro', value: 'delt' },
    { text: 'Distrito Capital', value: 'dist' },
    { text: 'Falcón', value: 'falc' },
    { text: 'Guárico', value: 'guar' },
    { text: 'Lara', value: 'lar' },
    { text: 'Mérida', value: 'mer' },
    { text: 'Miranda', value: 'mir' },
    { text: 'Monagas', value: 'mon' },
    { text: 'Nueva Esparta', value: 'nuev' },
    { text: 'Portuguesa', value: 'por' },
    { text: 'Sucre', value: 'sucr' },
    { text: 'Táchira', value: 'tac' },
    { text: 'Trujillo', value: 'tru' },
    { text: 'Vargas', value: 'var' },
    { text: 'Yaracuy', value: 'yar' },
    { text: 'Zulia', value: 'zl' },
  ]

  const leadChannelOptions = [
    { text: 'Whatsapp', value: 'WHATSAPP' },
    { text: 'Facebook', value: 'FACEBOOK' },
    { text: 'Instagram', value: 'INSTAGRAM' },
    { text: 'Google', value: 'GOOGLE' },
    { text: 'Correo Electrónico', value: 'EMAIL' },
    { text: 'Amigo', value: 'FRIEND' },
    { text: 'Otro', value: 'OTHER' },
  ]

  const invoiceMethodOptions = useMemo(() => {
    const baseOptions = [
      { text: 'Impresora fiscal', value: 'thermal_printer' },
      { text: 'Forma libre', value: 'free_form' },
    ]

    // Solo agregar "Factura digital" si el usuario tiene plan corporativo
    if (user?.['custom:user_plan'] === 'corporativo') {
      baseOptions.push({ text: 'Factura digital', value: 'digital' })
    }

    return baseOptions
  }, [user])

  const [image, setImage] = useState()

  return (
    <>
      <h1 className="font-bold text-2xl text-coolGray-900 mb-2 dark:text-white col-span-12">
        Registrar una cuenta
      </h1>

      <p className="font-normal text-gray-400 text-sm mb-2 col-span-12">
        Brindanos información para personalizar tu cuenta{' '}
      </p>

      <Form
        form={form}
        onSubmit={() => {}}
        classes="grid grid-cols-12 gap-4 items-end"
      >
        <div
          className="lg:col-span-3 col-span-12 row-span-3"
          style={{ alignSelf: 'anchor-center' }}
        >
          <InputUpload
            title="Sube el logo de tu empresa"
            fileType="image"
            handleImage={(img) => {
              setImage(img)
            }}
            deleteImage={() => {
              setImage(undefined)
            }}
            // containerClasses="xl:col-start-1 xl:row-span-3 xl:col-span-3 col-start-3 col-span-8 row-span-8 m-auto"
            imageClasses="rounded-md dark:border-gray-700"
            maxHeight="max-h-[250px]"
          />
        </div>

        <FormItem
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
          name="businessName"
          rules={{ required: 'Ingrese su nombre' }}
        >
          <InputText
            label="Nombre comercial de tu negocio"
            isUpperValue={false}
          />
        </FormItem>

        <FormItem
          classes="lg:col-span-4 col-span-12"
          name="phone"
          rules={{ required: 'Ingrese su teléfono' }}
        >
          <InputText label="Teléfono (Ej: 04121111111)" isUpperValue={false} />
        </FormItem>

        <FormItem
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
          name="businessSocial"
          rules={{ required: 'Ingrese su razón social' }}
        >
          <InputText label="Razón Social" isUpperValue={false} />
        </FormItem>

        <FormItem
          classes="lg:col-span-4 col-span-12"
          name="country"
          defaultValue={countries[0]}
        >
          <Select options={countries} label="País" disabled={true} />
        </FormItem>

        <FormItem
          name="document.documentType"
          defaultValue={docs[0]}
          rules={{ required: 'Es necesario el campo' }}
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
        >
          <Select options={docs} label="Tipo" />
        </FormItem>

        <FormItem
          classes="lg:col-span-4 col-span-12"
          name="document.document"
          rules={{ required: 'Ingrese su número de documento' }}
        >
          <InputText label="Número de documento legal" isUpperValue={false} />
        </FormItem>

        <FormItem
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
          name="state"
          defaultValue={states[0]}
        >
          <Select options={states} label="Estado" />
        </FormItem>

        <FormItem
          classes="lg:col-span-4 col-span-12"
          name="city"
          rules={{ required: 'Ingrese su ciudad' }}
        >
          <InputText label="Ciudad" isUpperValue={false} />
        </FormItem>

        <FormItem
          classes="lg:col-span-5 col-span-12 lg:col-start-4"
          name="postalCode"
        >
          <InputText label="Código postal (opcional)" isUpperValue={false} />
        </FormItem>

        <FormItem
          classes="lg:col-span-4 col-span-12"
          name="leadChannel"
          rules={{
            required: 'Ingrese el medio por el cual se enteró de Zerux',
          }}
        >
          <Select
            options={leadChannelOptions}
            label="¿Por cuál medio te enteraste de Zerux?"
            isUpperValue={false}
          />
        </FormItem>

        <FormItem
          classes="lg:col-start-4 lg:col-span-5 col-span-12"
          name="invoiceMethod"
          rules={{ required: 'Ingrese el método de facturación' }}
        >
          <Select
            options={invoiceMethodOptions}
            label="Método de facturación"
            isUpperValue={false}
          />
        </FormItem>

        <div className="flex flex-col items-end col-span-12">
          <div className="flex flex-col items-center">
            <div className="flex flex-row mr-5">
              {[...new Array(3)].map((_, i) => (
                <div
                  key={i}
                  className="mr-1"
                  style={{
                    width: 15,
                    height: 15,
                    backgroundColor: i === 1 ? '#006AEA' : '#D9D9D9',
                    borderRadius: 20,
                  }}
                ></div>
              ))}
            </div>

            <div className="flex flex-row mt-2">
              <div
                className="flex flex-row mr-5 items-center"
                onClick={() => {
                  onCancel()
                }}
              >
                <MdArrowBackIosNew className="mr-2" />
                <div className="cursor-pointer">Atrás</div>
              </div>

              <div
                className="flex flex-row items-center"
                onClick={() => {
                  const {
                    name,
                    phone,
                    businessName,
                    document,
                    city,
                    businessSocial,
                    leadChannel,
                    invoiceMethod,
                  } = form?.getValues()

                  if (
                    !phone ||
                    !businessName ||
                    !document ||
                    !city ||
                    !businessSocial ||
                    !leadChannel ||
                    !invoiceMethod
                  ) {
                    if (!phone) {
                      form.setError('phone', { message: 'Ingrese su teléfono' })
                    }

                    if (!businessName) {
                      form.setError('businessName', {
                        message: 'Ingrese el nombre del negocio',
                      })
                    }

                    if (!document.document) {
                      form.setError('document', {
                        message: 'Ingrese el documento',
                      })
                    }

                    if (!city) {
                      form.setError('city', { message: 'Ingrese la ciudad' })
                    }

                    if (!businessSocial) {
                      form.setError('businessSocial', {
                        message: 'Ingrese la razón social',
                      })
                    }

                    if (!leadChannel) {
                      form.setError('leadChannel', {
                        message:
                          'Ingrese el medio por el cual se enteró de Zerux',
                      })
                    }

                    if (!invoiceMethod) {
                      form.setError('invoiceMethod', {
                        message: 'Ingrese el método de facturación',
                      })
                    }

                    return
                  }

                  if (!/^(^(0412|0414|0416|0424)\d{7})$/.test(phone)) {
                    form.setError('phone', {
                      message: 'Formato de número telefónico inválido',
                    })
                    return
                  }

                  let newPhone = `+58${phone.slice(1)}`

                  setShowConfirmModal(true)

                  return

                  onSubmit({
                    ...form?.getValues(),
                    image,
                    address: {
                      ...form?.getValues(),
                      state: states.find(
                        (state) =>
                          state.value === form.getValues()?.address?.state
                      )?.text,
                    },
                    phone: newPhone,
                  })
                }}
              >
                <div className="text-primary cursor-pointer">{'Siguiente'}</div>
                <MdArrowForwardIos className="ml-2" />
              </div>
            </div>
          </div>
        </div>

        <Dialog
          open={showConfirmModal}
          onClose={() => {
            setShowConfirmModal(false)
          }}
        >
          <div className="p-4">
            <h1 className="text-center mb-3 text-[22px]">Importante</h1>
            <h4 className="text-center">
              Al registrarte, aceptas la veracidad y exactitud de la información
              suministrada. Soluciones Informáticas Wakuplus (J-413060540) no se
              hace responsable de posibles omisiones, errores o falsedades.{' '}
            </h4>
            <h4 className="mt-3 text-center">
              Asimismo, autorizas que los datos sean transmitidos al SENIAT
              conforme a la Providencia Administrativa SNAT/2024/000121. Todo
              incumplimiento podrá derivar en sanciones legales según la
              normativa tributaria vigente.
            </h4>
            <div className="col-span-12 h-full flex flex-row mt-5">
              <div className="w-1/2 mr-5 pl-1">
                <Button
                  onClick={() => setShowConfirmModal(false)}
                  type="outline"
                  classes="w-full"
                >
                  Cancelar
                </Button>
              </div>
              <div className="w-1/2 pr-1">
                <Button
                  type="primary"
                  classes="w-full"
                  onClick={() => {
                    let newPhone = `+58${form?.getValues()?.phone?.slice(1)}`

                    onSubmit({
                      ...form?.getValues(),
                      image,
                      address: {
                        ...form?.getValues(),
                        state: states.find(
                          (state) =>
                            state.value === form.getValues()?.address?.state
                        )?.text,
                      },
                      phone: newPhone,
                    })
                    setShowConfirmModal(false)
                  }}
                >
                  Confirmar
                </Button>
              </div>
            </div>
          </div>
        </Dialog>
      </Form>
    </>
  )
}

interface IRegisterForm {
  onCancel: () => void
  onSubmit: (values) => void
}

export default RegisterForm
